import { useExperiments } from '../contexts/ExperimentsContext';
import { resolveCategoryGroups } from '../config';

export const useCategoryGroups = () => {
  const experiments = useExperiments();
  const isStudioTemplatesSkipStyle = experiments.is(
    'specs.funnel.StudioTemplatesSkipStyle',
    'true',
  );
  const isStudioTemplatesNewTitle = experiments.is(
    'specs.funnel.StudioTemplatesNewTitle',
    'true',
  );
  const isStudioInspirationalTemplatesEnabled = experiments.is(
    'specs.funnel.StudioGalleryInspirationalTemplates',
    'true',
  );

  return resolveCategoryGroups(
    !isStudioTemplatesSkipStyle,
    isStudioTemplatesNewTitle,
    isStudioInspirationalTemplatesEnabled,
  );
};
